var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"hub-tablist"},_vm._l((_vm.tabs),function(tab,idx){return _c('li',{key:tab.id,staticClass:"hub-tablist__item"},[_c('button',{staticClass:"hub-tablist__button",class:{
        'hub-tablist__button--active': _vm.activeTabIdx === idx,
      },on:{"click":function($event){return _vm.handleTabClick(idx)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }